import { gql } from '@apollo/client';

/** Billing webhook queue (`webhookQueues`). */
export const GET_WEBHOOK_QUEUES = gql`
  query GetWebhookQueues($first: Int, $after: String, $where: WebhookQueueFilterInput) {
    webhookQueues(first: $first, after: $after, where: $where) {
      nodes {
        id
        status
        provider
        attempts
        processedAt
        errorMessage
        createdAt
        updatedAt
        payload
        headers
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;
